import Component from 'D:/zxl/workspace/saveWorkSpace/nongtou-uni/components/TreeItem.vue'
wx.createComponent(Component)